module.exports = __webpack_public_path__ + "static/img/img(56).695cf50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(56).png
// module id = Yje/
// module chunks = 1